import React, { useEffect, useRef, useState } from 'react';
import { SitePal } from 'sitepal-react-v2';

const ThreeDCharacter = () => {
    const [speechRecognition, setSpeechRecognition] = useState(null);
    const [sppechStopCalled, setSpeechStopCalled] = useState(0);
    const [isMacSafari, setIsMacSafari] = useState(0);
    const [firstemptyAudioPlayed, setFirstEmptyAudioPlayed] = useState(0);
    const [finalTranscript, setFinalTranscript] = useState("");
    const [textToSay, setTextToSay] = useState('');
    const [iframeContent, setIframeContent] = useState('');
    const frameContentRef = useRef(null);

    useEffect(() => {
        window.vh_aiResponse = (aiString) => {
            if (!textToSay.trim()) {
                console.error('Input is empty');
                return;
            }

            const aiResponse = aiString;
            const textTo_set = `<br><font color="#FF0000">Q - ${textToSay}</font><br><font color="#0000FF">A - ${aiResponse}</font>${iframeContent}`
            setIframeContent(textTo_set);

            if (frameContentRef.current) {
                const doc = frameContentRef.current.contentDocument;
                console.log('doc', doc, textTo_set)
                doc.open();
                doc.write(`<html><body bgcolor="#FFFFFF">${textTo_set}</body></html>`);
                doc.close();
            }

            setTextToSay('');
            document.querySelector("#interim").innerHTML = "";
        };

        if (("webkitSpeechRecognition" in window || "SpeechRecognition" in window) && !isFacebookApp()) {
            if (!speechRecognition) {
                initializeSpeechRecognition();
            }
        } else {
            handleSpeechRecognitionNotAvailable();
        }


        window.vh_talkEnded = () => {
            startSpeechRecognition() 
        }

    }, [textToSay]);

    const initializeSpeechRecognition = () => {
        const recognition = new (window.webkitSpeechRecognition || window.SpeechRecognition)();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.maxAlternatives = 1;
        recognition.lang = 'en-US';

        recognition.onstart = () => {
            document.querySelector("#status").style.display = "block";
        };

        recognition.onerror = (error) => {
            document.querySelector("#status").style.display = "none";
        };

        recognition.onend = () => {
            document.querySelector("#status").style.display = "none";
        };

        recognition.onresult = (event) => {
            handleSpeechRecognitionResult(event, recognition);
        };

        setSpeechRecognition(recognition);
    };

    const handleSpeechRecognitionResult = (event, recognition) => {
        let interimTranscript = "";

        if (sppechStopCalled == 1) {
            return;
        }

        for (let i = event.resultIndex; i < event.results.length; ++i) {
            if (event.results[i].isFinal && event.results[i][0].confidence > 0) {
                let transcript = event.results[i][0].transcript.trim();
                if (transcript !== "") {
                    document.querySelector("#status").style.display = "none";

                    if (recognition) {
                        setSpeechStopCalled(1);
                        recognition.stop();
                    }

                    setFinalTranscript(transcript);
                    setTextToSay(transcript);


                    window.sayAI(transcript, 1, 1, 3);
                }
            } else {
                interimTranscript += event.results[i][0].transcript;
                document.querySelector("#final").innerHTML = "";
                document.querySelector("#interim").innerHTML = interimTranscript;
            }
        }
    };

    const startSpeechRecognition = () => {
        if (isMacSafari === 1) {
            if (firstemptyAudioPlayed === 0) {
                window.saySilent(0);
            } else {
                setSpeechStopCalled(0);
                speechRecognition.start();
            }
        } else {
            setSpeechStopCalled(0);
            speechRecognition.start();
        }
    };

    const stopSpeechRecognition = () => {
        setSpeechStopCalled(1);
        speechRecognition.stop();
    };

    const isFacebookApp = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
    };

    const handleSpeechRecognitionNotAvailable = () => {
        console.log("Speech Recognition Not Available");
        stopSpeechRecognition();
        // Adjust UI or handle logic when Speech Recognition is not available
    };

    return (
        <div>
            <header className="main_header">
                <div className="left_div">
                    <div className="logo logo_heading">
                        <a href="/"><img src="https://www.sitepal.com/api/examples/images/logo.png" alt="SitePal" /></a>
                    </div>
                </div>
            </header>

            <table id="tblContainer" cellSpacing="0" align="center" border="0">
                <tbody>
                    <tr>
                        <td id="tdContent">
                            <p className="feature_entire_heading text-center f-bold h2" align="center"><b>AI Agent with Speech Input - Using React JS</b></p>
                            <p className="feature_entire_heading text-center" id="normal-text" align="center">In this example we demonstrate
                                an AI Agent that responds to speech input. <br />Read our <a className="selected_support"
                                    href="/docs/Implementing_Your_AI_Agent.pdf" target="_blank">technical note</a> to learn more.</p>
                            <p className="feature_entire_heading text-center" id="warning-text">Note: as we've detected this browser does not
                                yet support the Web Speech API we've automatically replaced speech input with text input.</p>


                            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                                <tbody>
                                    <tr>
                                        <td align="center" colSpan="2" className="feature_entire_heading text-center sayAi">
                                            {/* <!-- ******************************* SITEPAL EMBED CODE START  ***********************  --> */}
                                            <SitePal embed='16851,360,480,"",1,1, 2695840, 0,1,1,"5c6fde06460aa8ab405bf4f13cf93cf0",0' />
                                            {/* <!-- ******************************* SITEPAL EMBED CODE END  ***********************  --> */}
                                            <br />

                                            <form name="myForm" className="form" >
                                                {/* // <!-- <input name="textToSay" id="myInput" value="" className="form-control d-inline w-25"> */}

                                                <div className="p-3" id="p-3" style={{ border: "1px solid gray", height: "300px", borderRadius: "8px" }}>
                                                    <span id="final" className="text-light"></span>
                                                    <span id="interim" className="text-secondary"></span>
                                                </div>
                                                <div className="mt-4" id="mt-4">
                                                    <button type="button" id="start" onClick={startSpeechRecognition} >Start Recognition</button>
                                                    <button type="button" id="stop" onClick={stopSpeechRecognition}>Stop Recognition</button>
                                                    <p id="status" className="lead mt-3 text-light" style={{ display: "none" }}>Listening ...</p>
                                                </div>

                                                <br /><br />
                                            </form>
                                            <iframe id="simple-content" ref={frameContentRef} align="top" height="200" width="400"></iframe>
                                        </td>
                                    </tr>
                                    <tr align="middle">
                                        <td align="center" colSpan="2" className="feature_entire_heading text-center">
                                            <p>Real-time Artificial Intelligence Engine provides automatic Text and
                                                Audio responses to the questions provided. </p>
                                            <p>The Audio is generated automatically via a Text To Speech engine according to the selected voice and
                                                language.</p><br />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <footer>
                <div className="footer-menu oddcast text-center">
                    <ul className="w-50 m-auto ">
                        <li className="w-100 f-bold ">Please feel free to use the source code of this page as an example.</li>
                        <li>To view the source code of this page, <a href="/api/examples/react-ai-speak/Sitepal-react-speak-ai.zip"
                            download="">download </a>
                            source code</li>
                    </ul>
                </div>
            </footer>
        </div>
    );
};

export default ThreeDCharacter;
